import YouVisitAnalytics from './YouVisitAnalytics';

export default YouVisitAnalytics;
